import {Injectable} from '@angular/core';
import {ClVersion} from '@app/shared/changelog/version/clversion.model';
import {ChangelogSeenStore} from './changelogseen.store';
import {setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class ChangelogSeenService {
  constructor(private changelogSeenStore: ChangelogSeenStore) {
  }

  updateSeenVersions(newSeen: string[]) {
    this.changelogSeenStore.data.update(setProps({
      seenVersions: newSeen.slice()
    }));
  }

  getSeenVersions() {
    return this.changelogSeenStore.data.getValue().seenVersions.slice();
  }

  isVersionSeen(title: string): boolean {
    const ids: string[] = this.getSeenVersions();
    return !((ids === null) || (!ids.includes(title)));
  }

  setViewedVersions(title: string) {
    let ids: string[] = this.getSeenVersions();
    if (ids === null) {
      ids = [];
    }
    if (ids.indexOf(title) < 0) {
      ids.push(title);
      this.updateSeenVersions(ids);
    }
  }

  isVersionOld(version: ClVersion, days: number) {
    return ((Date.now() - version.date.getTime()) / 86400000) > days;
  }

  needsReading(versions: ClVersion[]): boolean {
    const ids: string[] = this.getSeenVersions();
    return (ids === null) || (!versions.every(elem => (ids.includes(elem.title)) || this.isVersionOld(elem, 60)));
  }

  clearChangelogSeenStore() {
    this.changelogSeenStore.data.reset();
  }
}
